import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useExperiences } from 'core/contexts/experienceV2';
import { Section } from 'modules/Pricing/styles';
import Layout from 'components/Layout';
import { Add } from '@mui/icons-material';
import { Button, Fade, Grid2, Typography } from '@mui/material';
import { CircularIndeterminate } from '@utriper/core-ui';
import ResourceCard from './components/ResourceCard';
import { AlertDialog } from '@utriper/core-ui';
import AddResourceForm from './components/AddResourceForm';

const ExperienceResourcePage = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const translate = (key) => t(`experience_resource.${key}`);
    const experienceId = parseInt(id);
    const { getExperienceById, removeResource, removeResourceCategory, loadResources, loading, loadingRes, experience, resources, resourceCategories } = useExperiences();
    const [openForm, setOpenForm] = useState(false);
    const [isCategory, setIsCategory] = useState(false);

    useEffect(() => {
        getExperienceById(experienceId, history);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experienceId]);

    useEffect(() => {
        loadResources(experienceId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [experienceId]);

    const handleClose = () => {
        setOpenForm(false);
        setIsCategory(false);
    };

    return (
        <Layout>
            {loading || loadingRes ? (
                <CircularIndeterminate centered />
            ) : (
                <Section style={{ overflow: 'visible' }}>
                    {/* Title */}
                    <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                        <Typography component="h1" fontSize={20} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                            {experience?.name}
                        </Typography>
                        <Typography component="p" fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }}>
                            {translate('subtitle')}
                        </Typography>
                    </Grid2>

                    <Fade in={!loadingRes} timeout={300}>
                        <Grid2 container size={12} spacing={2} mt={2}>
                            {/* Resources */}
                            <Grid2 container size={{ xs: 12, md: 6 }} height="fit-content">
                                <Grid2 container size={12} justifyContent="space-between" alignItems="center">
                                    <Typography fontSize={18} fontWeight={600} sx={{ color: '#131313' }}>
                                        {translate('resources.title')}
                                    </Typography>

                                    <Button
                                        sx={{
                                            backgroundColor: '#131313',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                        }}
                                        variant="contained"
                                        startIcon={<Add sx={{ color: '#fff', fontSize: '24px' }} />}
                                        onClick={() => setOpenForm(true)}
                                    >
                                        {translate('resources.add')}
                                    </Button>
                                </Grid2>

                                {/* Cards */}
                                <Grid2 container size={12} spacing={2}>
                                    <Grid2 container size={12} spacing={2} justifyContent="center">
                                        {resources?.length > 0 ? resources.map(({ id, name, notificationEmail, notificationWhatsapp, email, mobilePhone }) => <ResourceCard key={id} id={id} experienceId={experienceId} name={name} notificationEmail={notificationEmail} notificationWhatsapp={notificationWhatsapp} email={email} mobilePhone={mobilePhone} onRemove={removeResource} />) : translate('resources.no_data')}
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                            {/* Resource Categories */}
                            <Grid2 container size={{ xs: 12, md: 6 }} height="fit-content">
                                <Grid2 container size={12} justifyContent="space-between" alignItems="center">
                                    <Typography fontSize={18} fontWeight={600} sx={{ color: '#131313' }}>
                                        {translate('categories.title')}
                                    </Typography>

                                    <Button
                                        sx={{
                                            backgroundColor: '#131313',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                        }}
                                        variant="contained"
                                        startIcon={<Add sx={{ color: '#fff', fontSize: '24px' }} />}
                                        onClick={() => {
                                            setOpenForm(true);
                                            setIsCategory(true);
                                        }}
                                    >
                                        {translate('categories.add')}
                                    </Button>
                                </Grid2>

                                {/* Cards */}
                                <Grid2 container size={12} spacing={2} justifyContent="center">
                                    {resourceCategories?.length > 0 ? resourceCategories.map(({ id, name, notificationEmail, notificationWhatsapp }) => <ResourceCard key={id} id={id} experienceId={experienceId} name={name} notificationEmail={notificationEmail} notificationWhatsapp={notificationWhatsapp} onRemove={removeResourceCategory} isCategory />) : translate('categories.no_data')}
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Fade>

                    <AlertDialog open={openForm} handleClose={handleClose} hideTitle hideActions maxWidth="sm" fullWidth dialogContent={<AddResourceForm experienceId={experienceId} handleClose={handleClose} isCategory={isCategory} />} />
                </Section>
            )}
        </Layout>
    );
};

export default ExperienceResourcePage;
